import { Pipe, PipeTransform } from '@angular/core';
import { DriverDataBusinessType } from '@shared/enums';
import { BusinessHelper } from '@shared/utils/business-helper';

@Pipe({
  name: 'businsessTypesTransform',
  standalone: true
})
export class BusinsessTypesTransform implements PipeTransform {

  constructor() { }
  transform(value: DriverDataBusinessType[]): string {
    return BusinessHelper.GetCombinedBusinessType(value);
  }
}
